'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Td = exports.Th = exports.Tr = exports.TFoot = exports.THead = exports.TBody = exports.Table = exports.TableTitle = exports.TableContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./Table.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TableContainer = function TableContainer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['className', 'children']);

  return _react2.default.createElement(
    'div',
    _extends({ className: (0, _classnames2.default)('vs-table-container', className) }, rest),
    children
  );
};

exports.TableContainer = TableContainer;
var TableTitle = function TableTitle(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ['className', 'children']);

  return _react2.default.createElement(
    'div',
    _extends({ className: (0, _classnames2.default)('vs-table-title', className) }, rest),
    children
  );
};

exports.TableTitle = TableTitle;
var Table = function Table(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ['className', 'children']);

  return _react2.default.createElement(
    'table',
    _extends({ className: (0, _classnames2.default)('vs-table', className) }, rest),
    children
  );
};

exports.Table = Table;
var TBody = function TBody(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ['className', 'children']);

  return _react2.default.createElement(
    'tbody',
    _extends({ className: (0, _classnames2.default)('vs-tbody', className) }, rest),
    children
  );
};

exports.TBody = TBody;
var THead = function THead(_ref5) {
  var className = _ref5.className,
      children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ['className', 'children']);

  return _react2.default.createElement(
    'thead',
    _extends({ className: (0, _classnames2.default)('vs-thead', className) }, rest),
    children
  );
};

exports.THead = THead;
var TFoot = function TFoot(_ref6) {
  var className = _ref6.className,
      children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, ['className', 'children']);

  return _react2.default.createElement(
    'tfoot',
    _extends({ className: (0, _classnames2.default)('vs-tfoot', className) }, rest),
    children
  );
};

exports.TFoot = TFoot;
var Tr = function Tr(_ref7) {
  var className = _ref7.className,
      children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ['className', 'children']);

  return _react2.default.createElement(
    'tr',
    _extends({ className: (0, _classnames2.default)('vs-row', className) }, rest),
    children
  );
};

exports.Tr = Tr;
var buildCellClasses = function buildCellClasses(center, className, nowrap, right) {
  return (0, _classnames2.default)('vs-cell', className, { 'vs-cell-right': right }, { 'vs-cell-center': center }, { 'vs-cell-nowrap': nowrap });
};

var Th = function Th(_ref8) {
  var center = _ref8.center,
      className = _ref8.className,
      nowrap = _ref8.nowrap,
      right = _ref8.right,
      children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, ['center', 'className', 'nowrap', 'right', 'children']);

  return _react2.default.createElement(
    'th',
    _extends({ className: buildCellClasses(center, className, nowrap, right) + ' vs-table-header' }, rest),
    children
  );
};

exports.Th = Th;
var Td = function Td(_ref9) {
  var center = _ref9.center,
      className = _ref9.className,
      nowrap = _ref9.nowrap,
      right = _ref9.right,
      children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, ['center', 'className', 'nowrap', 'right', 'children']);

  return _react2.default.createElement(
    'td',
    _extends({ className: buildCellClasses(center, className, nowrap, right) }, rest),
    children
  );
};
exports.Td = Td;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack/lib/components/Table/Table.js
// module id = 560
// module chunks = 0